import { jsonrepair } from 'jsonrepair';

export function extractAndParseJSON(text: string) {
  if (!text) throw new Error('Empty response from AI');

  const cleanText = text.replace(/<thinking>[\s\S]*?(?:<\/thinking>|$)/gi, '').trim();

  const parseAndValidate = (content: string) => {
    const parsed = JSON.parse(jsonrepair(content));
    if (typeof parsed !== 'object' || parsed === null || Array.isArray(parsed)) {
      throw new Error('Parsed result is not an object or array');
    }
    return parsed;
  };

  const markdownRegex = /```(?:json)?\s*([\s\S]*?)\s*```/gi;
  let match;
  while ((match = markdownRegex.exec(cleanText)) !== null) {
    const content = match[1].trim();
    try {
      return parseAndValidate(content);
    } catch {
      // try next block
    }
  }

  const firstBrace = cleanText.indexOf('{');
  const firstBracket = cleanText.indexOf('[');
  let start = -1;

  if (firstBrace !== -1 && (firstBracket === -1 || firstBrace < firstBracket)) {
    start = firstBrace;
  } else if (firstBracket !== -1) {
    start = firstBracket;
  }

  if (start !== -1) {
    try {
      return parseAndValidate(cleanText.substring(start));
    } catch {
      // fallback below
    }
  }

  try {
    return parseAndValidate(cleanText);
  } catch (error) {
    console.error('Final JSON Parse Attempt Failed. Text sample:', cleanText.substring(0, 500));
    throw new Error(
      `Failed to parse AI response as JSON: ${error instanceof Error ? error.message : String(error)}`,
    );
  }
}
